import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const testimonials = [
    {
        name: "Marek K.",
        location: "Katowice",
        platform: "Fixly",
        rating: 5,
        text: "Ekipa Pana Mariusza to prawdziwi fachowcy. Od bezpłatnego pomiaru do zakończenia prac pełen profesjonalizm. Nowy dach wygląda niesamowicie, a cena na umowie ani drgnęła. Polecam każdemu, kto ceni spokój.",
    },
    {
        name: "Anna S.",
        location: "Mysłowice",
        platform: "Google",
        rating: 5,
        text: "Bardzo rzetelna firma. Panowie doradzili fajne rozwiązanie z ociepleniem, zrobili wszystko w terminie, a po robocie zostawili idealny porządek. Szybko, konkretnie i na lata. 10/10.",
    },
    {
        name: "Krzysztof N.",
        location: "Sosnowiec",
        platform: "Fixly",
        rating: 5,
        text: "Konkurencja dawała dziwne, zmienne wyceny. W Tobmar od razu wiedziałem na czym stoję. Tynk położony wzorowo, certyfikowane materiały, ekipa zgrana. Naprawdę nie ma się do czego przyczepić.",
    }
];

export default function Testimonials() {
    const sectionRef = useRef(null);
    const titleRef = useRef(null);
    const cardsRef = useRef([]);

    useEffect(() => {
        let ctx = gsap.context(() => {
            // Reveal Title
            gsap.from(titleRef.current, {
                scrollTrigger: {
                    trigger: titleRef.current,
                    start: "top 85%",
                },
                y: 30,
                opacity: 0,
                duration: 1,
                ease: "power3.out"
            });

            // Stagger Reveal Cards
            gsap.from(cardsRef.current, {
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 75%",
                },
                y: 50,
                opacity: 0,
                duration: 1.2,
                stagger: 0.15,
                ease: "power3.out"
            });

        }, sectionRef);

        return () => ctx.revert();
    }, []);

    return (
        <section ref={sectionRef} className="py-24 md:py-32 px-6 md:px-16 bg-background">
            <div className="max-w-7xl mx-auto">
                <div ref={titleRef} className="text-center mb-16 md:mb-24">
                    <span className="font-mono text-xs md:text-sm uppercase tracking-widest text-[#E3000F] font-bold mb-4 block">Dowód Jakości</span>
                    <h2 className="font-heading font-black text-[clamp(2.5rem,4vw,4rem)] text-dark leading-tight uppercase tracking-tighter">
                        Co mówią o nas inwestorzy
                    </h2>
                    <p className="font-body text-dark/70 text-lg md:text-xl max-w-2xl mx-auto mt-6">
                        Zostawiamy po sobie nie tylko solidne i szczelne dachy płaskie, ale przede wszystkim spokojnych i zadowolonych klientów na całym Śląsku.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, idx) => (
                        <div
                            key={idx}
                            ref={el => cardsRef.current[idx] = el}
                            className="h-full"
                        >
                            <div className="relative bg-background border border-dark/10 shadow-sm rounded-3xl p-8 md:p-10 flex flex-col justify-between h-full hover:shadow-xl hover:-translate-y-2 hover:border-accent/20 transition-all duration-500 overflow-hidden group">
                                {/* Decorative Background Quote */}
                                <div className="absolute -top-10 -right-4 text-[12rem] font-serif text-dark/[0.03] select-none pointer-events-none leading-none group-hover:text-accent/[0.05] transition-colors duration-500">
                                    "
                                </div>

                                <div className="relative z-10">
                                    <div className="flex justify-between items-start mb-8">
                                        <div className="flex gap-1.5">
                                            {[...Array(testimonial.rating)].map((_, i) => (
                                                <svg key={i} className="w-5 h-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
                                                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                                </svg>
                                            ))}
                                        </div>
                                        <span className="font-mono text-[10px] bg-dark/5 text-dark/70 border border-dark/10 px-3 py-1 rounded-full font-bold uppercase tracking-widest">
                                            {testimonial.platform}
                                        </span>
                                    </div>

                                    <p className="font-body text-dark/80 text-[1.1rem] leading-relaxed mb-10 italic relative">
                                        {testimonial.text}
                                    </p>
                                </div>

                                <div className="relative z-10 flex items-center gap-4 border-t border-dark/10 pt-6">
                                    <div className="w-12 h-12 bg-primary border border-dark/10 text-dark rounded-full flex items-center justify-center font-heading font-bold text-xl shrink-0 group-hover:bg-accent group-hover:text-background group-hover:border-transparent transition-colors duration-500">
                                        {testimonial.name.charAt(0)}
                                    </div>
                                    <div>
                                        <h4 className="font-heading font-bold text-dark text-lg md:text-xl tracking-tight">{testimonial.name}</h4>
                                        <p className="font-mono text-[10px] text-dark/50 uppercase tracking-widest mt-1">{testimonial.location}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
